import { EntitySortUtil } from '@core/utils/entity-sort.util';
import { ContactSort } from '@shared/contact/contact-sort.util';
import { Donation } from '@shared/donation/donation';

export class DonationSort {
  static byFullName = (a: Donation, b: Donation): number => ContactSort.byFullName(a.donor, b.donor);
  static byEmailAddress = (a: Donation, b: Donation): number => ContactSort.byEmailAddress(a.donor, b.donor);
  static byAmount = (a: Donation, b: Donation): number => a.amount - b.amount;
  static byFrequency = (a: Donation, b: Donation): number =>
    EntitySortUtil.byEnumValue(a.paymentFrequency, b.paymentFrequency);
  static byStopOnDate = (a: Donation, b: Donation): number => EntitySortUtil.byDateValue(a.stopOnDate, b.stopOnDate);
}
